import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const MapPin = ({
  width = 17,
  height = 18,
  className,
  color,
  decorative = false,
  ariaLabel = "Map pin",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 17 18"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.3"
        d="M12.894 4.472A4.327 4.327 0 0 0 8.572.15 4.327 4.327 0 0 0 4.25 4.472 4.324 4.324 0 0 0 8.284 8.78v8.083a.288.288 0 1 0 .576 0V8.779a4.324 4.324 0 0 0 4.034-4.307ZM8.572 8.218a3.75 3.75 0 0 1-3.746-3.746A3.75 3.75 0 0 1 8.572.726a3.75 3.75 0 0 1 3.746 3.746 3.75 3.75 0 0 1-3.746 3.746Z"
      />
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.3"
        d="M7.131 2.167a1.154 1.154 0 0 0 0 2.305 1.154 1.154 0 0 0 0-2.305Zm0 1.729a.577.577 0 1 1 .001-1.154.577.577 0 0 1 0 1.154Z"
      />
    </svg>
  );
};
